import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const preSignedURLPageStyle = css`
  li::before {
    content: counter(step-counter) ".";
    color: red;
    display: inline-block;
    margin-left: -1em;
    margin-right: 1em;
  }
  li::marker {
    display: none;
  }
  li {
    counter-increment: step-counter;
  }
  a {
    color: ${color.black};
  }
`;
